import { useState } from "react";

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="space-y-3">
      {items.map((item, index) => {
        const isOpen = open === index;
        return (
          <div key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? null : index)}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
            >
              <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">{item.q}</span>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
              </span>
            </button>
            {isOpen && (
              <p className="px-4 pb-5 text-sm leading-relaxed text-foreground-600 md:px-5">{item.a}</p>
            )}
          </div>
        );
      })}
    </div>
  );
}